import React from 'react';

export default function IconBoxStyle5({ title, subTitle, iconUrl }) {
  return (
    <div className="cs_iconbox cs_style_5 cs_white_bg cs_radius_15">
      <div className="cs_iconbox_icon cs_center cs_accent_bg cs_radius_15">
        <img src={iconUrl} alt="Icon" />
      </div>
      <div className="cs_iconbox_content" style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <h2 className="cs_iconbox_title m-0 cs_fs_20 cs_medium">{title}</h2>
        {subTitle && (
          <p className="cs_iconbox_subtitle m-0 cs_fs_16" style={{ lineHeight: 1.6, color: 'inherit', opacity: 0.9 }}>
            {subTitle}
          </p>
        )}
      </div>
    </div>
  );
}
